export class Heap<T> {
    private heapArray: HeapNode<T>[];
    private heapSize: number;

    constructor(public ascending: boolean, initialSize?: number) {
        if (initialSize) {
            this.heapArray = new Array<HeapNode<T>>(initialSize);
        } else {
            this.heapArray = [];
        }

        this.heapSize = 0;
    }

    public get length(): number {
        return this.heapSize;
    }

    public isEmpty(): boolean {
        return this.heapSize == 0;
    }

    public insert(element: T, value: number): void {
        let node = new HeapNode<T>(element, value);

        this.heapArray[this.heapSize] = node;
        this.moveUp(this.heapSize);
        this.heapSize++;
    }

    public pop(): HeapNode<T> {
        if (this.heapSize > 0) {
            let root = this.heapArray[0];
            this.heapArray[0] = this.heapArray[--this.heapSize];

            this.moveDown(0);

            return root;
        } else {
            return null;
        }
    }

    public peek(): HeapNode<T> {
        if (this.heapSize > 0) {
            return this.heapArray[0];
        } else {
            return null;
        }
    }

    private moveUp(index: number): void {
        let parentIndex = Math.floor((index - 1) / 2);
        let last = this.heapArray[index];
        
        while (index > 0 && this.moveCompare(this.heapArray[parentIndex].value, last.value)) {
            this.heapArray[index] = this.heapArray[parentIndex];
            index = parentIndex;
            parentIndex = Math.floor((parentIndex - 1) / 2);
        }

        this.heapArray[index] = last;
    }

    private moveDown(index: number): void {
        let largerIndex: number;
        let top = this.heapArray[index];

        while (index < Math.floor(this.heapSize / 2)) {
            let leftIndex = 2 * index + 1;
            let rightIndex = 2 * index + 2;

            if (rightIndex < this.heapSize // ensure node has two children (last node may have only one)
                && this.moveCompare(this.heapArray[leftIndex].value, this.heapArray[rightIndex].value)) {
                largerIndex = rightIndex;
            } else {
                largerIndex = leftIndex;
            }

            if (this.breakCompare(top.value, this.heapArray[largerIndex].value)) {
                break;
            }

            this.heapArray[index] = this.heapArray[largerIndex];
            index = largerIndex;
        }

        this.heapArray[index] = top;
    }

    private breakCompare(a: number, b: number): boolean {
        if (this.ascending) {
            return b >= a;
        } else {
            return a >= b;
        }
    }

    private moveCompare(a: number, b: number): boolean {
        if (this.ascending) {
            return b < a;
        } else {
            return a < b;
        }
    }
}

class HeapNode<T> {

    constructor(public element: T, public value: number) {

    }
}